import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mt-3.5 max-w-271 max-md:mb-5 lg:mt-6 lg:px-7.5',
    content:
      '[&_h2]:heading-xl lg:[&_h2]:heading-2xl [&_h3]:heading-m-bold lg:[&_h3]:heading-xl text-sm leading-[1.7] font-light text-black lg:text-lg [&_a]:underline [&_a]:underline-offset-2 [&_h2]:mb-3 [&_p]:mb-3',
    button:
      'heading-xs mt-3 flex h-auto items-center gap-2 px-0 font-semibold lg:mt-4',
    buttonIcon: 'size-6 transition-transform'
  },
  variants: {
    expanded: {
      false: {
        content: 'line-clamp-[16] lg:line-clamp-8'
      }
    }
  }
});
